import { render, staticRenderFns } from "./Nuovo-Utente.vue?vue&type=template&id=d5d48b48&scoped=true&"
import script from "./Nuovo-Utente.vue?vue&type=script&lang=js&"
export * from "./Nuovo-Utente.vue?vue&type=script&lang=js&"
import style0 from "./Nuovo-Utente.vue?vue&type=style&index=0&id=d5d48b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d48b48",
  null
  
)

export default component.exports